const getters = {
  // Example
  isLoading: (state) => {
    return state.isLoading;
  },

  isLoadingUnity: (state) => {
    return state.isLoadingUnity;
  },

  isAdmin: (state) => {
    return state.authentication.isAdmin
  },
};

export default getters;
